import type { TFunction } from "@/hooks/useTranslation"

export const getUrgentFilterOptions = (t: TFunction) => [
  {
    value: "RULE_PRIORITY_URGENT",
    label: t("urgent")
  },
  {
    value: "RULE_PRIORITY_WARNING",
    label: t("warning")
  },
  {
    value: "RULE_PRIORITY_NOTICE",
    label: t("notice")
  }
]
